

$(document).ready(function() {
  console.log("testss");
   $('.hidefancy a').attr('href', '#');

  $('.hidefancy a').click(function(e){
  e.preventDefault();
  $('html, body').animate({scrollTop: 220}, 'fast');
});
  
  $('.template-product a.lightbox-trigger:not(.hidefancy a)').fancybox({
     arrows: false,
  infobar: false,
  toolbar: false,
  touch: false,
  transitionEffect: "slide",
  clickOutside: true,
  transitionDuration: 500
  });

    $(".\#slideshow-thumbnails-inner .lightbox-trigger").off("click.fb");
  

  $(document).on('click', function(e) {
  if ($(e.target).closest('.fancybox-container').length === 0) {
    $.fancybox.close();
  }
});
});